import { render, staticRenderFns } from "./StockDetailTemplate.vue?vue&type=template&id=398dc882&"
import script from "./StockDetailTemplate.vue?vue&type=script&lang=js&"
export * from "./StockDetailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports